<template>
	<div>
		<b-card class="p-1 mr-1" no-body>
			<b-overlay :show="isLoading">
				<b-row class="mb-1">
					<b-col class="d-flex justify-content-start">
						<strong class="d-flex align-items-center text-primary text-center">
							TOTAL DE TEMPERAMENTOS : {{ rows.length }}
						</strong>
					</b-col>
					<b-col class="d-flex justify-content-end">
						<b-button class="d-inline text-nowrap" variant="outline-primary" @click="handleOpenModal()">
							<FeatherIcon icon="PlusIcon" size="20" />
						</b-button>
					</b-col>
				</b-row>
				<b-table-simple sticky-header="60vh">
					<b-thead class="text-center">
						<b-tr>
							<b-th>Nombre</b-th>
							<b-th>Activa</b-th>
							<b-th>Fecha de Creación</b-th>
							<b-th>Acciones</b-th>
						</b-tr>
					</b-thead>
					<b-tbody class="text-center">
						<b-tr v-for="row in rows" :key="row.id">
							<b-td>{{ row.name }}</b-td>
							<b-td>
								<b-badge pill :variant="'light-' + (row.is_active ? 'success' : 'danger')">
									{{ row.is_active ? "SÍ" : "NO" }}
								</b-badge>
								<b-form-checkbox
									v-model="row.is_active"
									:true-value="1"
									:false-value="0"
									name="check-button"
									switch
									class="mt-1 text-center"
									@change="switchActive(row)"
									style="margin-left: 0.5rem"
								/>
							</b-td>
							<b-td>
								{{ row.created_at | myGlobalDayWithHour }}
							</b-td>
							<b-td>
								<div class="d-flex justify-content-center" style="gap: 1rem">
									<feather-icon
										size="20"
										icon="EditIcon"
										class="text-primary cursor-pointer"
										@click.prevent="handleOpenModal(true, row)"
									/>
									<feather-icon
										size="20"
										icon="TrashIcon"
										class="text-danger cursor-pointer"
										@click.prevent="deleteTemperament(row)"
									/>
								</div>
							</b-td>
						</b-tr>
						<b-tr v-if="rows.length == 0">
							<b-td colspan="4">
								<p class="mb-0">No hay registros por mostrar</p>
							</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</b-overlay>
		</b-card>
		<b-modal
			centered
			v-model="creationModal.show"
			:title="`${creationModal.editing ? 'Actualizando' : 'Creando nuevo'} temperamento`"
			@hidden="creationModal.show = false"
		>
			<b-overlay :show="creationModal.loading">
				<ValidationObserver ref="form">
					<ValidationProvider rules="required" v-slot="{ errors }" class="w-100">
						<b-form-group label="Nombre">
							<b-form-input
								:class="{ 'border-danger': errors[0] }"
								placeholder="Ingrese el nombre"
								v-model="creationModal.name"
								@input="creationModal.name = creationModal.name.toUpperCase()"
							/>
						</b-form-group>
					</ValidationProvider>
				</ValidationObserver>
			</b-overlay>
			<template #modal-footer>
				<b-button variant="info" @click="updateTemperament()" v-if="creationModal.editing">Actualizar</b-button>
				<b-button variant="success" @click="storeTemperament" v-else>Guardar</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import TemperamentService from "@/views/brain/specimens/views/temperaments/services/temperament.service.js"
export default {
	components: {},
	data: () => ({
		isLoading: false,
		rows: [],
		creationModal: {
			loading: false,
			show: false,
			editing: false,
			name: "",
		},
	}),
	computed: {},
	methods: {
		async getTemperaments() {
			this.isPreloading()
			try {
				const { data } = await TemperamentService.getTemperaments()
				this.rows = data.map((reason) => ({
					...reason,
					is_active: reason.is_active === 1 ? true : false,
				}))
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},

		async storeTemperament() {
			if (!(await this.$refs.form.validate())) return
			this.isPreloading()
			try {
				const res = await TemperamentService.storeTemperament({
					name: this.creationModal.name,
				})
				this.getTemperaments()
				this.handleHidden()
				this.showSuccessToast(res.message)
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},

		async switchActive(row) {
			const { isConfirmed } = await this.showConfirmSwal({
				title: `¿Estás seguro de que quieres ${row.is_active ? "activar" : "desactivar"} a ${row.name}?`,
				text: "",
			})
			if (!isConfirmed) {
				row.is_active = !row.is_active
				return
			}
			try {
				const { message } = await TemperamentService.switchActive(row.id)
				this.getTemperaments()
				this.showSuccessToast(message)
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},

		async updateTemperament() {
			if (!(await this.$refs.form.validate())) return
			const { isConfirmed } = await this.showConfirmSwal()
			if (!isConfirmed) return
			try {
				const { message } = await TemperamentService.updateTemperament(this.creationModal.id, {
					name: this.creationModal.name,
				})
				this.getTemperaments()
				this.handleHidden()
				this.showSuccessToast(message)
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},

		async deleteTemperament(row) {
			const { isConfirmed } = await this.showConfirmSwal()
			if (!isConfirmed) return
			try {
				const { message } = await TemperamentService.deleteTemperament(row.id)
				this.getTemperaments()
				this.showSuccessToast(message)
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},

		handleOpenModal(isEditing = false, temperament = null) {
			this.creationModal = {
				id: isEditing ? temperament.id : null,
				loading: false,
				show: true,
				editing: isEditing,
				name: isEditing ? temperament.name : "",
			}
		},
		handleHidden() {
			this.creationModal = {
				id: null,
				loading: false,
				show: false,
				editing: false,
				name: "",
			}
		},
	},
	watch: {},
	mounted() {
		this.getTemperaments()
	},
}
</script>
<style lang="scss" scoped>
.container-number {
	height: 50px;
	width: 50px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	margin: 0 0.1rem;
	p {
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bolder !important;
	}
}
</style>
